import { PostHogProvider as PostHogProviderOrig } from "posthog-js/react";
import posthog, { PostHog } from "posthog-js";
import { env } from "~/env.mjs";

// // // //
// Initialize Posthog Client

// Define references to Posthog SDK Key + host
const NODE_ENV = process.env.NODE_ENV;
const NEXT_PUBLIC_POSTHOG_KEY = env.NEXT_PUBLIC_POSTHOG_KEY;
const NEXT_PUBLIC_POSTHOG_HOST = env.NEXT_PUBLIC_POSTHOG_HOST;

let client: PostHog | undefined = undefined;

// Only initialize Posthog in client (no SSR) when environment variables are present
if (
    typeof window !== "undefined" &&
    NEXT_PUBLIC_POSTHOG_HOST &&
    NEXT_PUBLIC_POSTHOG_KEY
) {
    client = posthog.init(NEXT_PUBLIC_POSTHOG_KEY, {
        api_host: "/ingest", // Proxy through Next.js API routes
        ui_host: "https://us.posthog.com",
        defaults: "2026-01-30",
        capture_pageview: "history_change",
        capture_pageleave: true,
        capture_exceptions: true,
        // Disable `autocapture` (testing to see impact on monthly pricing)
        // Doc: https://posthog.com/docs/product-analytics/autocapture
        autocapture: false,
        debug: NODE_ENV === "development",
        person_profiles: "always", // create profiles anonymous + authenticated users
        loaded: (posthog) => {
            if (NODE_ENV === "development") {
                posthog.debug(); // Uncomment to enable debug mode in development
            }
        },
    });
}

// // // //

/**
 * PostHogProvider
 * Wraps the original PostHogProvider component with some logic to
 * skip initialization if the required environment variables aren't present
 */
export function PostHogProvider(props: { children: React.ReactNode }) {
    if (client === undefined) {
        return <>{props.children}</>;
    }

    return (
        <PostHogProviderOrig client={client}>
            {props.children}
        </PostHogProviderOrig>
    );
}
